/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import styled from 'styled-components';

import { icons } from '../../../../assets';
import { colors } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const BadgeStatusStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `badge-status ${className || ''}`,
}))<IAttrStyled>`
    display: flex;
    align-items: center;
    width: fit-content;
    max-width: 450px;
    padding: 4px 8px;
    border: 1px solid ${colors.borderColorDisabled};
    border-radius: 16px;

    &:hover {
        background-color: ${colors.backgroundColorHoverOpacity};
    }

    &:before {
        content: '';
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background-repeat: no-repeat;
        background-size: contain;
    }

    &.badge-status_active {
        color: ${colors.textColorSuccess};

        &:before {
            background-image: url(${icons.successIcon});
        }
    }

    &.badge-status_changed {
        color: ${colors.textColorOpacity};

        &:before {
            background-image: url(${icons.timeIconWarning});
        }
    }

    &.badge-status_future {
        color: ${colors.textColorOpacity};

        &:before {
            background-image: url(${icons.timeIconBlue});
        }
    }

    &.badge-status_blocked {
        color: ${colors.textColorOpacity};

        &:before {
            background-image: url(${icons.timeIconDanger});
        }
    }
`;
